import { useT as baseUseT } from '@guiker/react-framework'

export const useT = (args: { screenName?: string; entity?: string }) => baseUseT({ ...args, domain: 'account' })
